import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import "../assets/style/core.css"
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import { faArrowUpFromBracket, faAward, faBrain, faCircleExclamation, faClock, faFaceSmileBeam, faFaceSmileWink, faFaceSurprise, faFlagCheckered, faGamepad, faGun, faMugHot, faPeopleGroup, faPhone, faRightToBracket, faRunning, faShuttleSpace, faSmileWink, faSurprise, faTimeline, faTimes, faTimesCircle, faTrophy, faUser } from "@fortawesome/free-solid-svg-icons";
import { faIntercom, faMeetup, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import managerImg from "../assets/img/designing.png"

function Designing() {
    useEffect(() => {
        AOS.init();
    }, []);
    useEffect(() => {
        AOS.init();
    }, []);
    return (
        <>
            <Navbar />
            <section>
                <div className='container'>
                    <div className='p-md-5 p-3'>
                        <h1 className='text-primary text-center mb-1 mt-4'>DESIGNEX -Unleash The Power Of Visual Story Telling</h1>
                        <div className='row'>
                            <div className='col-lg-6'>
                                <div className="hero-content darkBlue-text" data-aos="fade-right" data-aos-duration="1200">
                                    <p>Join us for an exciting event where photography and design come
together in a warm, supportive setting. It's a chance to showcase 
your creativity and innovative ideas while connecting with fellow  enthusiasts. Don't miss this opportunity to elevate your talents and celebrate creativity with us!
                                    </p>
                                </div>
                            </div>
                            <div className='col-lg-6 d-flex justify-content-center align-items-center'>
                                <img src={managerImg} height={300} data-aos="fade-up" data-aos-duration="1800" className='img-ani' />
                            </div>
                        </div>
                        <h4 className='darkBlue-text'>Rules and Regulations</h4>
                        <ul className='darkBlue-text'>
                        <li className='darkBlue-text'>No. of participants - 1</li>
                            <li className='darkBlue-text'>Students should have basic knowledge of Designing apps/software.
</li>
                            <li className='darkBlue-text'>Participants are requested to bring their mobile phones.
</li>
                            <li className='darkBlue-text'>Judges decision is final</li>
                        </ul>

                    </div>
                </div>

                <div className='hero-wrapper'>
                    <div className="container">
                        <div className="p-md-5 text-center mt-5">
                            <div className="row">
                                <h1 className='mb-5 text-white mt-5'>Pre Requisite</h1>
                                <div className="col-sm" data-aos="zoom-in" data-aos-duration="800">
                                    <p className="h5 mt-2 mb-4 text-white">Get your Mobile and chargers
</p>
                                </div>
                                <div className="col-sm" data-aos="zoom-in" data-aos-duration="1800">
                                    <p className="h5 mt-2 mb-4 text-white">One laptop with adobe photoshop and davinci resolve installed.</p>
                                </div>
                                <div className="col-sm" data-aos="zoom-in" data-aos-duration="1000">
                                    <p className="h5 mt-2 mb-4 text-white">Exhibit effective time management skills with executive paints</p>
                                </div>
                            </div>
                            <h1 className='mb-3 text-white mt-4 text-decoration-underline'>Contact / Help</h1>
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2 className='text-white mt-3'>Student Coordinator : </h2>
                                    <h5 className='text-white' data-aos="zoom-in" data-aos-duration="800"> Mr. Vishwanath R N - <a className="text-white me-3 btn btn-sm  btn-secondary" href="https://wa.me/918660854864"><FontAwesomeIcon icon={faWhatsapp} size="lg" /></a></h5>
                                    <h5 className='text-white' data-aos="zoom-in" data-aos-duration="800"> Miss. Shreedevi C - <a className="text-white me-3 btn btn-sm  btn-secondary" href="https://wa.me/9686034520"><FontAwesomeIcon icon={faWhatsapp} size="lg" /></a></h5></div>
                                <div className="col-lg-6">
                                    <h2 className='text-white mt-3'>Faculty Coordinator : </h2>
                                    <h5 className='text-white' data-aos="zoom-in" data-aos-duration="800"> Prof.Ashwatth U   </h5>
                                    <h5 className='text-white' data-aos="zoom-in" data-aos-duration="800">   Prof.Maheshrao     </h5>
                                    <h5 className='text-white' data-aos="zoom-in" data-aos-duration="800">   Prof.Savita   </h5>
                                    <h5 className='text-white' data-aos="zoom-in" data-aos-duration="800">   Prof.Tejaswini     </h5>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <h4 className='text-center p-5 darkBlue-text text-decoration-underline'>Let your imagination come to life on the digital canvas!
                </h4>
            </section>
            <Footer />
        </>
    )
}

export default Designing